// QUAIS CAMINHOS PEDEM CONTA — e esta lista existe para a TELA poder dizer isso antes do clique.
//
// ── O ACHADO (T9.11) ────────────────────────────────────────────────────────────────────────
//
// O QA, em 02/10/2026, medindo a página inicial:
//
//     botão "Escrever a história toda" ....... 443 por 87 pontos, abre a ferramenta
//     botão "Montar quadro por quadro" ....... 490 por 96 pontos, leva ao login
//     algum dos dois avisa que pede conta .... nenhum
//     passos do bloco "Como uma história nasce aqui" que levam ao login .... 2 de 4
//
// Dois botões do mesmo tamanho e do mesmo peso, lado a lado, e um deles bate num pedido de login.
// *"A única explicação aparece depois do clique, já dentro da tela de entrar."*
//
// ── POR QUE A LISTA MORA AQUI, E NÃO NA TELA ────────────────────────────────────────────────
//
// Porque o fato é da GUARDA, não da home. `GuardaDoAcervo` é quem manda para o login, e ela
// envolve quatro rotas. Uma etiqueta escrita na home, com a rota digitada à mão, viraria mentira
// no dia em que a guarda mudar — e mentira na direção pior, porque a tela estaria prometendo que
// não pede conta.
//
// Com a lista aqui, a guarda e a etiqueta leem a mesma linha. E o teste de
// `pede-conta-antes-do-clique.test.ts` confere o contrário: toda tela que usa a guarda está
// coberta por esta lista.
//
// ── E A ETIQUETA SÓ APARECE PARA QUEM NÃO TEM CONTA ─────────────────────────────────────────
//
// Quem já entrou não precisa de aviso sobre uma porta que está aberta para ela, e repetir o aviso
// em todo botão transformaria a informação em ruído — que é como um aviso deixa de ser lido.

/** Os prefixos de rota que `GuardaDoAcervo` protege. */
export const ROTAS_QUE_PEDEM_CONTA = ["/meus-quadrinhos"];

/** Esta rota vai bater num pedido de login? */
export function pedeConta(rota: string): boolean {
  const limpa = (rota || "").split("?")[0];
  return ROTAS_QUE_PEDEM_CONTA.some((p) => limpa === p || limpa.startsWith(`${p}/`));
}

/** O que a tela escreve ao lado do caminho que pede conta. Uma frase, um lugar. */
export const AVISO_DE_CONTA = "precisa de conta";
